let generation = 0;
export function prfSessionGeneration(): number {
	return generation;
}
export function endPrfSession(): void {
	generation++;
}
export function assertPrfSession(expected: number): void {
	if (expected !== generation) {
		throw new Error("Backup unlock cancelled.");
	}
}
